import { render, staticRenderFns } from "./SearchBar.vue?vue&type=template&id=fb645f84&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=ts"
export * from "./SearchBar.vue?vue&type=script&lang=ts"
import style0 from "./SearchBar.vue?vue&type=style&index=0&id=fb645f84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb645f84",
  null
  
)

export default component.exports